module.exports = __webpack_public_path__ + "static/media/loading.f63e6ae3.svg";